
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import Enums from '@/lib/enums'
    import CreateStock from './stock-add.vue'
    import EditStock from './stock-edit.vue'
    import SupplyModel from './stockup-add.vue'
    import QuickStock from './quickstock-add.vue'
    import frontPrinting from './front-printing.vue'
    import storeaddressInfo from '@/store/entities/back-storeaddress-list';
    import DateUtils from '@/common/js/DateUtils'
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    import moment from 'moment'
    Vue.use(Preview);

    class PageFrontStockRequest extends PageRequest {
        beginTime?: Date;
        endTime?: Date;
        isCheckBy?: boolean;
        logisticsNumber: string;
        storeId?: number;
        productSku: string;
        productCode: string;
        productStatus?: number;
    }

    @Component({
        name: "frontstock",
        components: { CreateStock, EditStock, SupplyModel, QuickStock, frontPrinting }
    })
    export default class FrontStock extends AbpBase {
        editModalShow: boolean = false;
        supplyModalShow: boolean = false;
        quickModalShow: boolean = false;
        storeaddressList: Array<storeaddressInfo> = [];
        pagerequest: PageFrontStockRequest = new PageFrontStockRequest();
        ProductStatus = Enums.getEnum(Enums.ProductStatus, true);
        IsCheckedStatus = Enums.getEnum(Enums.IsCheckStatus, true);
        creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
        createModalShow: boolean = false;
        printingModalShow: boolean = false;
        get list() {
            return this.$store.state.frontstock.list;
        };
        get loading() {
            return this.$store.state.frontstock.loading;
        }
        async add() {
            this.createModalShow = true;
        }
        pageChange(page: number) {
            this.$store.commit('frontstock/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('frontstock/setPageSize', pagesize);
            this.getpage();
        }
        async searchPage() {
            this.$store.state.user.currentPage = 1;
            this.getpage();
        }
        async quickmodel(data: any) {
            if (data.storeCost) {
                this.$Modal.error({ title: "错误", content: "公开库存不允许用户自己补单！" });
                return;
            }
            this.$store.state.frontstock.stockmodel = data;
            this.quickModalShow = true;
        }
        async getpage() {

            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            //filters

            if (this.creationTime.length > 0) {
                this.pagerequest.beginTime = this.creationTime[0];
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.endTime = this.creationTime[1];
            }
            this.getData();
            await this.$store.dispatch({
                type: 'frontstock/getAll',
                data: this.pagerequest
            })

        }
        async getData() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            })
            var a = new storeaddressInfo();
            a.id = null;
            a.storeName = "全部";
            this.storeaddressList = this.$store.state.backstoreaddress.list;
            this.storeaddressList.push(a);
        }
        async showmodel(data: any) {
            this.$store.state.frontstock.stockmodel = data;
            this.editModalShow = true;
        }
        async stockup(data: any) {
            this.$store.state.frontstock.id = data.id;
            this.supplyModalShow = true;
        }
        async cancleModel(data: any) {
            var _this = this;
            _this.$Modal.confirm({
                title: "取消入库单", content: "确定是否取消该入库单？", width: 800, onOk: async () => {
                    setTimeout(async () => {
                        await _this.$store.dispatch({
                            type: 'frontstock/cancleStock',
                            data: { Id: data.id }
                        })
                        _this.getpage();
                    }, 500);
                }
            });
        }
        get pageSize() {
            return this.$store.state.frontstock.pageSize;
        }
        get totalCount() {
            return this.$store.state.frontstock.totalCount;
        }
        get currentPage() {
            return this.$store.state.frontstock.currentPage;
        }
        async printing(data: any) {
            this.$store.state.backstockproduct.barCode = data.barCode;
            this.$store.state.backstockproduct.printNumber = data.productNums;
            this.$store.state.backstockproduct.shelfPosition = (data.shelfPosition ? data.shelfPosition : "") + "_" + data.productId;
            this.printingModalShow = true;
        }

        async open(data: any) {
            var pdfData = {
                barCode: data.barCode,
                shelfPosition: (data.shelfPosition ? data.shelfPosition : "") + "_" + data.productId,
                imageUrl: "",
                url: '',
            };
            this.$store.commit('fontorder/getPdfUrl', pdfData);
            if (pdfData.url && pdfData.url.length > 0) {
                window.open(pdfData.url);
            }
        }
        columns = [
        //{
        //    title: '国内物流单号',
        //     key: 'logisticsNumber',
        //    width: 150,

        //    },
            {
                title: '备货信息',
                width: 240,
                render: (h: any, params: any) => {
                    var a = "red";
                    return h('div', [h('h3', "国内物流单号:" + (params.row.logisticsNumber == null ? "" : params.row.logisticsNumber)), h('h3', "打包件数:" + (params.row.packageNums == null ? "" : params.row.packageNums)), h('h3', { style: { color: a } }, "产品状态：" + (params.row.productStatus == null ? "" : Enums.ProductStatus.filter(function (item) { return item.value == params.row.productStatus })[0].name))])
                }
            },
            {
            title: '备货入库仓库',
                key: 'storeName',
            width: 150,
            fixed: 'left',
            },
            {
                title: '产品信息',
                width: 450,
                render: (h: any, params: any) => {
                    var a = "red";
                    return h('div', [h('h3', "类型:" + Enums.ProductType.filter(function (item) { return item.value == params.row.productType })[0].name), h('h3', "SKU:" + (params.row.productSku)), h('h3', "名称:" + (params.row.productName)), h('h3', "链接:" + (params.row.productLink)), h('h3', "数量:" + (params.row.productNums)), h('h3', "采购成本:" + (params.row.purchaseCost)+"元"), h('h3', { style: { color: a } }, "备注：" + (params.row.remark == null ? "" : params.row.remark))])
                }
            },
            {
                title: '内码',
                key: 'productId',
                width: 90,
            },
            {
                title: '产品编码',
                key: 'barCode',
                width: 90,
            },

        //{
        //    title: '产品类型',
        //    width: 90,
        //    key: 'productType',
        //    render: (h: any, params: any) => {
        //        return h('span', Enums.ProductType.filter(function (item) { return item.value == params.row.productType })[0].name);
        //    }
        //    },
            {
                title: '产品图片',
                key: 'productImgGuid',
                width: 95,
                render: (h: any, params: any) => {
                    if (params.row.productImgGuid) {
                        var data = { imageGuid: params.row.productImgGuid, url: null };
                        var url = "";
                        if (params.row.productImgGuid.indexOf("http") != -1) {
                            url = params.row.productImgGuid;
                        }
                        else {
                            this.$store.commit('expressuserinfo/getImgUrl', data);
                            url = data.url;;
                        }
                        return h('img', {
                            style: {
                                width: "50px",
                                height: "50px",
                                verticalAlign: "middle"
                            },
                            attrs: {
                                src: url,
                                preview: "yc_" + params.row.id,
                                "preview-text": params.row.orderNumber + "cp"
                            }
                        });

                    } else {
                        return h('span', "");
                    }
                }
            },
            //{
            //title: '产品Sku',
            //    key: 'productSku',
            //width: 80,
            //},
            {
            title: '用户编码',
            key: 'userCode',
            width: 90,
            },
            {
                title: '库存单价',
                key: 'storeCost',
                width: 90,
            },
            {
            title: '是否审核通过',
                key: 'isCheckBy',
            width: 120,
                render: (h: any, params: any) => {
                    return h('span', params.row.isCheckBy == null ? this.L('审核中') : (params.row.isCheckBy ? this.L('审核通过') : this.L('审核未通过')))
            }
            },
            {
                title: '异常备注',
                key: 'abnormalRemark',
                width: 90,
            }, 
            //{
            //    title: '扣费详情',
            //    width: 280,
            //    render: (h: any, params: any) => {
            //        return h('div', [h('h3', "开始扣费时间:" + (params.row.beginDeductionTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.beginDeductionTime)))), h('h3', "扣费周期:" + (params.row.deductionCycle == null ? "" : params.row.deductionCycle + "天")), h('h3', "扣除积分/周期:" + (params.row.deductIntegral == null ? "" : params.row.deductIntegral + "积分")), h('h3', "上架费:" + (params.row.shelfCost == null ? "" : params.row.shelfCost + "积分"))])
            //    }
            //},

            //{
            //    title: '打包数量',
            //    key: 'packageNums',
            //    width: 90,
            //}, 
            //{
            //    title: '商品链接',
            //    key: 'productLink',            //{
            //    title: '开始扣费时间',
            //    key: 'beginDeductionTime',
            //    width: 150,
            //    render: (h: any, params: any) => {
            //        return h('span', params.row.beginDeductionTime == null ? "" :DateUtils.formatLongDate(new Date(params.row.beginDeductionTime)));
            //    }
            //},
            //{
            //    title: '扣费积分',
            //    key: 'deductIntegral',
            //    width: 200,
            //}, 
            //{
            //    title: '扣费周期/积分',
            //    key: 'deductionCycle',
            //    width: 200,
            //}, 
            //    width: 200,
            //}, 
            //{
            //    title: '商品名称',
            //    key: 'productName',
            //    width: 200,
            //}, 
            //{
            //    title: '商品数量',
            //    key: 'productNums',
            //    width: 200,
            //}, 
            //{
            //    title: '采购成本',
            //    key: 'purchaseCost',
            //    width: 200,
            //}, 
            {
                title: '时间',
                width: 230,
                render: (h: any, params: any) => {
                    return h('div', [h('h3', "创建时间:" + (params.row.creationTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.creationTime)))), h('h3', "更新时间:" + (params.row.lastModificationTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.lastModificationTime)))), h('h3', "审核时间:" + (params.row.checkTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.checkTime))))])
                }
            },
            {
                title: '异常图片',
                key: 'abnormalImageGuid',
                width: 95,
                render: (h: any, params: any) => {
                    if (params.row.abnormalImageGuid) {
                        var data = { imageGuid: params.row.abnormalImageGuid, url: null };
                        var url = "";
                        if (params.row.abnormalImageGuid.indexOf("http") != -1) {
                            url = params.row.abnormalImageGuid;
                        }
                        else {
                            this.$store.commit('expressuserinfo/getImgUrl', data);
                            url = data.url;;
                        }
                        return h('img', {
                            style: {
                                width: "50px",
                                height: "50px",
                                verticalAlign: "middle"
                            },
                            attrs: {
                                src: url,
                                preview: "yc_" + params.row.id,
                                "preview-text": params.row.orderNumber + "cp"
                            }
                        });

                    } else {
                        return h('span', "");
                    }
                }
            },
            //{
            //title: '创建时间',
            //    key: 'creationTime',
            //width: 150,
            //    render: (h: any, params: any) => {
            //        return h('span', DateUtils.formatLongDate(new Date(params.row.creationTime)));
            //}
            //},
            //{
            //    title: '更新时间',
            //    key: 'lastModificationTime',
            //    width: 150,
            //    render: (h: any, params: any) => {
            //        return h('span', params.row.lastModificationTime == null ? "" :DateUtils.formatLongDate(new Date(params.row.lastModificationTime)));
            //    }
            //},
         //{
         //   title: '备注',
         //   width: 220,
         //   key: 'reMark',
         // },
            {
                title: '操作',
                width: 120,
                fixed: 'right',
                key: 'id',
                render: (h: any, params: any) => {
                    var data = params.row;
                    var _this = this;
                    return h('div', [
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '90px',
                                height: '30px',
                                display: params.row.isCheckBy == null || params.row.productStatus==4 ? "inline-block" : "none",
                                
                            },
                            on: {
                                click: () => {
                                    _this.showmodel(params.row);
                                    
                                }
                            }

                        }, "修改"),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '90px',
                                height: '30px',
                                display: params.row.productStatus == 4 ? "inline-block" : "none",

                            },
                            on: {
                                click: () => {
                                    _this.cancleModel(params.row);

                                }
                            }

                        }, "取消"),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '90px',
                                height: '30px',
                                display: params.row.isCheckBy == true && (params.row.productStatus == 0 || params.row.productStatus==null) ? "inline-block" : "none",

                            },
                            on: {
                                click: () => {
                                    _this.stockup(params.row);

                                }
                            }

                        }, "补充备货信息"),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '90px',
                                height: '30px',
                                display: params.row.productStatus == 3 && !params.row.storeCost ? "inline-block" : "none",

                            },
                            on: {
                                click: () => {
                                    _this.quickmodel(params.row);

                                }
                            }

                        }, "补货"),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '80px',
                                height: '30px',
                                display: "inline-block",
                            },
                            on: {
                                click: () => {
                                    _this.printing(params.row);

                                }
                            }

                        }, "打印条形码")
                        ,
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '80px',
                                height: '30px',
                                display: "inline-block",
                            },
                            on: {
                                click: () => {
                                    _this.open(params.row);

                                }
                            }

                        }, "查看条形码")
                    ]);
                }
            }
        ]
        async created() {

            this.getpage();
        }
    }
